import { render } from "./ExamDetail.vue?vue&type=template&id=53f6e862"
import script from "./ExamDetail.vue?vue&type=script&lang=ts"
export * from "./ExamDetail.vue?vue&type=script&lang=ts"

import "./ExamDetail.vue?vue&type=style&index=0&id=53f6e862&lang=css"
script.render = render

export default script